module.exports = __webpack_public_path__ + "static/img/b3.82b74e5a.png";